import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-arrow-right-up-icon]',
  template: `
    <svg:path
      d="M9 5L18 5C18.5523 5 19 5.44772 19 6L19 15C19 15.5523 18.5523 16 18 16C17.4477 16 17 15.5523 17 15L17 8.41421L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L15.5858 7L9 7C8.44771 7 8 6.55229 8 6C8 5.44772 8.44771 5 9 5Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
    '[class]': 'extraClass()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArrowRightUpIcon {
  readonly viewBox = input<string>('0 0 24 24');
  readonly extraClass = input<string>('');
}
